// File: src/components/common/HazardModal.jsx
import React from "react";
import {
  CModal,
  CCard,
  CCardBody,
  CButton,
  CFormTextarea,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilWarning } from "@coreui/icons";

const HazardModal = ({ visible, onClose, onSave, textValue, onTextChange }) => {
  // console.log("Rendering HazardModal with textValue:", textValue);
  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CCard className="m-0">
        <CCardBody>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 text-primary">Hazard Declaration Details</h5>
            <CButton color="light" className="p-0" onClick={() => onClose(true)}>
              <span aria-hidden="true">&times;</span>
            </CButton>
          </div>

          {/* Body */}
          <CFormTextarea
            rows={5}
            value={textValue}
            onChange={(e) => onTextChange(e.target.value)}
            placeholder="Describe the type of hazard, safety handling measures, or special requirements..."
          />

          {/* Footer */}
          <div className="mt-3">
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "0.5rem",
                backgroundColor: "#fff8e1", // light amber/yellow tone
                border: "1px solid #ffe58f",
                borderRadius: "6px",
                padding: "0.75rem",
                color: "#856404",
                fontSize: "0.9rem",
                marginBottom: "1rem",
              }}
            >
              <CIcon icon={cilWarning} size="lg" />
              <div>
                Please provide any known risks, handling precautions, or safety
                measures associated with this hazardous material.
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <CButton color="primary" className="me-2" onClick={onSave}>
                Save
              </CButton>
              <CButton color="secondary" variant="outline" onClick={() => onClose(true)}>
                Cancel
              </CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CModal>
  );
};

export default HazardModal;
